import { configureStore } from '@reduxjs/toolkit';
import tagsReducer from './slices/tagsSlice';
import donationFormReducer from './slices/donationFormSlice';

export const store = configureStore({
  reducer: {
    tags: tagsReducer,
    donationForm: donationFormReducer,
  },
});
